import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { axiosGet } from "../../api/Axios";

const initialState: IChatState = {
  isSubmitting: false,
  error: null,
  meta: [],
  userChat: {
    currentPage: 1,
    entries: [],
    hasMore: true,
    totalMessages: 0,
    totalPages: 0,
  },
  selectedUser: null,
  incomingMessageCount: 0,
};
export const getChatByUserIdApi = createAsyncThunk(
  "/admin/chats/getChatByUserId",
  async (
    { userId, page }: { userId: string; page: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosGet<IUserChat>(
        `/admin/chats/getChatByUserId?userId=${userId}&page=${page}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllChatsMetaApi = createAsyncThunk(
  "admin/chats/getAllChatsMeta",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<IChatMeta[]>(
        "admin/chats/getAllChatsMeta"
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Create the auth slice
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    selectUserToChat: (state, action: PayloadAction<IChatMeta>) => {
      state.userChat = {
        currentPage: 1,
        entries: [],
        hasMore: true,
        totalMessages: 0,
        totalPages: 0,
      };
      state.selectedUser = action.payload;
    },
    pushNewMessage: (state, action: PayloadAction<IMessage>) => {
      state.userChat.entries.push(action.payload);
      state.incomingMessageCount++;
    },
    updateMeta: (state, action: PayloadAction<IChatMeta[]>) => {
      state.meta = action.payload;
    },
    updatePageToRequestMoreMessages: (state) => {
      if (state.userChat.hasMore) {
        state.userChat.currentPage++;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllChatsMetaApi.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(getAllChatsMetaApi.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.meta = action.payload;
      })
      .addCase(getAllChatsMetaApi.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set the error message
      })
      .addCase(getChatByUserIdApi.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(getChatByUserIdApi.fulfilled, (state, action) => {
        if (action.payload.currentPage === 1) {
          state.incomingMessageCount++;
        }
        state.userChat = {
          ...action.payload,
          entries: [...action.payload.entries, ...state.userChat.entries],
        };
        state.isSubmitting = false;
      })
      .addCase(getChatByUserIdApi.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set the error message
      });
  },
});

// Export actions and reducer
export const {
  selectUserToChat,
  pushNewMessage,
  updateMeta,
  updatePageToRequestMoreMessages,
} = chatSlice.actions;
export default chatSlice.reducer;
